// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nfmHj","colBig":"styles_colBig__r80-r","colSmall":"styles_colSmall__3ckUM","shopifyNameWrapper":"styles_shopifyNameWrapper__sItU0"};